export function validateFields(fields, stateLocation) {
	let returner = true;
	fields.map((key, index) => {
		let curFieldValid = true
		let curField = this.refs[key];
		if(curField.props.type && curField.props.type==="number"){
	      if(curField.props.value){
	        if(curField.props.minValue.toString().length){
	          if(Number.parseInt(curField.props.value)<Number.parseInt(curField.props.minValue)){
	          	returner = false;
	          	curFieldValid = false;
	          }
	        }
	        if(curField.props.maxValue.toString().length){
	          if(Number.parseInt(curField.props.value)>Number.parseInt(curField.props.maxValue)){
	          	returner = false;
	          	curFieldValid = false;
	          }
	        }
	        if(!curFieldValid) {
	        	if(stateLocation) {
		          	this.setState(prevState => ({
	                    form_state : {
	                        ...prevState.form_state,
	                        [stateLocation]: {
	                        	...prevState.form_state[stateLocation],
		                        [key] : {
		                            state : 'error',
		                            message : this.props.translate('global.error.invalid.number',{min: curField.props.minValue ? curField.props.minValue : 0, max: curField.props.maxValue ? curField.props.maxValue : 0})
		                        }
	                        }
	                    }
	                }))
	           	}
	           	else {
		          	this.setState(prevState => ({
	                    form_state : {
	                        ...prevState.form_state,
	                        [key] : {
	                            state : 'error',
	                            message : this.props.translate('global.error.invalid.number',{min: curField.props.minValue ? curField.props.minValue : 0, max: curField.props.maxValue ? curField.props.maxValue : 0})
	                        }
	                    }
	                }))	           		
	           	}
	        }
	      }
	    } 
	    else if (curField.props.type && curField.props.type === "password") {
			const regexCheck = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/g;
	    	if(curField.props.value.toString().length && !curField.props.value.match(regexCheck)) {
	          	returner = false;
	          	curFieldValid = false;
	        	if(stateLocation) {
   	          		this.setState(prevState => ({
	                    form_state : {
	                        ...prevState.form_state,
	                        [stateLocation]: {
	                        	...prevState.form_state[stateLocation],
		                        [key] : {
		                            state : 'error',
		                            message : this.props.translate('global.error.invalid.password')
		                        }
		                    }
	                    }
	                }))
	        	}
	        	else {
	   	          	this.setState(prevState => ({
	                    form_state : {
	                        ...prevState.form_state,
	                        [key] : {
	                            state : 'error',
	                            message : this.props.translate('global.error.invalid.password')
	                        }
	                    }
	                }))	        		
	        	}
	    	}
	    }
	    if(curFieldValid && curField.props.shouldMatch && curField.props.value.toString().length && this.refs[curField.props.shouldMatch].props.value.toString().length && curField.props.value.toString() !== this.refs[curField.props.shouldMatch].props.value.toString()) {
			returner = false;
			curFieldValid = false;
	        if(stateLocation) {
		        this.setState(prevState => ({
	                form_state : {
	                    ...prevState.form_state,
	                    [stateLocation]: {
	                    	...prevState.form_state[stateLocation],
		                    [key] : {
		                        state : curField.props.value.toString().length ? 'error' : false,
		                        message : this.props.translate('global.error.match.'+curField.props.type)
		                    },
		                    [curField.props.shouldMatch] : {
		                        state : this.refs[curField.props.shouldMatch].props.value.toString().length ? 'error' : false,
		                        message : this.props.translate('global.error.match.'+curField.props.type)
		                    }
		                }
	                }
	            }))
	        }
	        else {
	        	this.setState(prevState => ({
	                form_state : {
	                    ...prevState.form_state,
	                    [key] : {
	                        state : curField.props.value.toString().length ? 'error' : false,
	                        message : this.props.translate('global.error.match.'+curField.props.type)
	                    },
	                    [curField.props.shouldMatch] : {
	                        state : this.refs[curField.props.shouldMatch].props.value.toString().length ? 'error' : false,
	                        message : this.props.translate('global.error.match.'+curField.props.type)
	                    }
	                }
	            }))
	        }
	    }
	    if(curFieldValid && curField.props.isRequired && !curField.props.value.toString().length){
	        returner = false;
	        curFieldValid = false;
        	if(stateLocation) {
	          	this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        [stateLocation]: {
                        	...prevState.form_state[stateLocation],
	                        [key] : {
	                            state : 'error',
	                            message : this.props.translate('global.error.required.default')
	                        }
                        }
                    }
                }))
           	}
           	else {
	          	this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        [key] : {
                            state : 'error',
                            message : this.props.translate('global.error.required.default')
                        }
                    }
                }))	           		
           	}
	    }
	    if(curFieldValid && curField.props.shouldBe) {
	    	/* Returns true if a test is failed. With this function it will only test until it fails */
	    	const regexEmail = /^(([\w-]+\.)+[\w-]+|([a-zA-Z]{1}|[\w-]{2,}))@((([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])){1}|([a-zA-Z0-9]+[\w-]+\.)+[a-zA-Z]{1}[a-zA-Z0-9-]{1,23})$/g
	    	Object.entries(curField.props.shouldBe).some((entry, index) => {
	    		let type = entry[0];
	    		if(type === 'email' && !curField.props.value.toString().match(regexEmail)) {
	    			returner = false;
					curFieldValid = false;
					if(stateLocation) {
			          	this.setState(prevState => ({
		                    form_state : {
		                        ...prevState.form_state,
		                        [stateLocation]: {
		                        	...prevState.form_state[stateLocation],
			                        [key] : {
			                            state : 'error',
	                            		message : this.props.translate('global.error.shouldbe.email')
			                        }
		                        }
		                    }
		                }))
		           	}
		           	else {
			          	this.setState(prevState => ({
		                    form_state : {
		                        ...prevState.form_state,
		                        [key] : {
		                            state : 'error',
	                            	message : this.props.translate('global.error.shouldbe.email')
		                        }
		                    }
		                }))	           		
		           	}  
	    			return true;
	    		}
	    	})
	    }
	    if(curFieldValid) {
	    	if(curField.props.shouldMatch) {
	    		if(stateLocation) {
		    		if(this.state.form_state[stateLocation][key].state === 'error' || curField.props.showValidAlways) {
			          	this.setState(prevState => ({
		                    form_state : {
		                        ...prevState.form_state,
		                        [stateLocation]: {
		                        	...prevState.form_state[stateLocation],
			                        [key] : {
			                            state : curField.props.value.toString().length ? 'success' : false,
			                            message : null
			                        },
			                        [curField.props.shouldMatch] : {
			                            state : this.refs[curField.props.shouldMatch].props.value.toString().length ? 'success' : false,
			                            message : null
			                        }
		                        }
		                    }
		                }))
		            }
	           	}
	           	else {
		    		if(this.state.form_state[key].state === 'error' || curField.props.showValidAlways) {
			          	this.setState(prevState => ({
		                    form_state : {
		                        ...prevState.form_state,
		                        [key] : {
		                            state : curField.props.value.toString().length ? 'success' : false,
		                            message : null
		                        },
		                        [curField.props.shouldMatch] : {
		                            state : this.refs[curField.props.shouldMatch].props.value.toString().length ? 'success' : false,
		                            message : null
		                        }
		                    }
		                }))	       
		            }    		
	           	}
	    	}
	    	else {
		    	if(stateLocation) {
		    		if(this.state.form_state[stateLocation][key].state === 'error' || curField.props.showValidAlways) {
			          	this.setState(prevState => ({
		                    form_state : {
		                        ...prevState.form_state,
		                        [stateLocation]: {
		                        	...prevState.form_state[stateLocation],
			                        [key] : {
			                            state : 'success',
			                            message : null
			                        }
		                        }
		                    }
		                }))
		            }
	           	}
	           	else {
		    		if(this.state.form_state[key].state === 'error' || curField.props.showValidAlways) {
			          	this.setState(prevState => ({
		                    form_state : {
		                        ...prevState.form_state,
		                        [key] : {
		                            state : 'success',
		                            message : null
		                        }
		                    }
		                }))	       
		            }    		
	           	}
	        }
	    }
    });
    return returner
}


// WEBPACK FOOTER //
// ./src/_helpers/Form.js